import './index_web.css';
import FixturesMatchList from '../fixtures_match_list';
import LiveMatchList from '../live_match_list';
import ResultMatchList from '../result_match_list';
import { MatchTabBar } from '../../component';

import { View } from '../../../component';

const MatchTabWeb = ({
  fixtureList,
  liveList,
  resultList,

  onChangeTab,
  activeTab,
  routes
}: any) => {
  return (
    <>
      <div className="matchtab__tabsContainer">
        <MatchTabBar activeTab={activeTab} onChangeTab={onChangeTab} routes={routes} />
      </div>
      <div className="matchTab__matchList__container__web">
        <View className={'match-tab-content'}>
          {activeTab === 0 && <FixturesMatchList list={fixtureList} />}
        </View>
        <View className={'match-tab-content'}>
          {activeTab === 1 && <LiveMatchList list={liveList} />}
        </View>
        <View className={'match-tab-content'}>
          {activeTab === 2 && <ResultMatchList list={resultList} />}
        </View>
      </div>
    </>
  );
};

export default MatchTabWeb;
